// @ts-check

import { checkObject } from 'libs/types/checkTypes';
import convertAddresses from './convertAddresses';

/**
 * @function convertUser
 * @param {ProfileUser} user
 * @param {Object} pwdObj
 * @param {string} pwdObj.password
 * @param {string} pwdObj.confirmPassword
 * @returns {object} result
 */
function convertUser(user, pwdObj) {
	checkObject(user, pwdObj);

	const {
		id,
		contactId,
		firstName,
		lastName,
		companies,
		vFileId,
		emailWork,
		emailPersonal,
		emailOther,
		contactTypes,
		phoneWork,
		phoneWorkDialCode,
		phoneWorkCountryCode,
		phoneWorkExt,
		phoneMobile,
		phoneMobileDialCode,
		phoneMobileCountryCode,
		phoneMobileExt,
		phoneOther,
		phoneOtherDialCode,
		phoneOtherCountryCode,
		phoneOtherExt,
		note,
		languageIds,
		username,
		isEnabled,
		masterCustId,
		roles,
		addresses,
		addressIds,
	} = user;

	const { password, confirmPassword } = pwdObj;

	const newAddresses = convertAddresses(addresses, addressIds);

	const newUser = {
		Id: id,
		ContactId: contactId,
		FirstName: firstName,
		LastName: lastName,
		Customers: companies,
		VFileId: Number(vFileId),
		WorkEmail: emailWork,
		PersonalEmail: emailPersonal,
		OtherEmail: emailOther,
		ContactTypes: contactTypes,
		WorkPhone: phoneWork,
		WorkPhoneDialCode: phoneWorkDialCode,
		WorkPhoneCountryCode: phoneWorkCountryCode,
		WorkPhoneExtension: phoneWorkExt,
		CellPhone: phoneMobile,
		CellPhoneDialCode: phoneMobileDialCode,
		CellPhoneCountryCode: phoneMobileCountryCode,
		CellPhoneExtension: phoneMobileExt,
		HomePhone: phoneOther,
		HomePhoneDialCode: phoneOtherDialCode,
		HomePhoneCountryCode: phoneOtherCountryCode,
		HomePhoneExtension: phoneOtherExt,
		Note: note,
		Languages: languageIds,
		UserName: username,
		UserPassword: password,
		ConfirmPassword: confirmPassword,
		IsEnabled: isEnabled,
		MasterCustomerId: masterCustId,
		UserRoles: roles,
		Addresses: newAddresses,
	};

	return newUser;
}

export default convertUser;
